import { IGrantType } from "../../../components/Modals/PwdMgmtModals/OTPModal/module/constants";
import { generalConst } from "../../../module/globalInterface";

export const LOGIN_ROUTES: generalConst = {
  LOGIN: "/login",
};

export const LOGIN_FORM = "LoginForm";

export interface IDomains {
  applicationId: string;
  applicationName: string;
  identitySystemId: string;
}

export const STATE_IDENTIFIER = {
  FIRST_ACCESS: "firstAccess",
  OLD_PASSWORD: "oldPwd",
  DOMAINS: "domains",
  QUESTIONS: "questions",
  QUESTIONS_LOADER: "questionsLoader",
  ANSWER: "answer",
  USER: "user",
  OTP: "otp",
  REQUEST_STATE_QUESTION: "requestStateQuestion",
  REQUEST_STATE_OTP: "requestStateOtp",
  TOKEN_TMP: "tokenTmp",
  TOKEN_TYPE: "tokenType",
  PASSW_POLICY: "passwordPolicy",
  RETRYS: "retrys",
  REQUEST_STATE_PASSWORD: "requestStatePassword",
  GENERATE_OTP_CALL_STATE: "generateOTPCallState",
  GENERATE_OTP_RECEIVER: "generateOTPReceiver",
};

export interface IPostAnswer {
  id: string | null;
  answer: string;
}

export interface IDataPostLogin {
  grant_type: IGrantType;
  username: string;
  password: string | IPostAnswer[];
  client_id: string;
}

export const TOKEN_SCOPE = {
  FORCE_CHG_PWD: "UIGP_ChangePassword",
  INTERNET_ACCESS: "UIGP_OTP",
  BASIC_ACCESS: "UIGP",
};
